import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import index from '../views/index';
import Mar202011Vue from '../views/Mar202011';
import Mar202023Vue from '../views/Mar202023';
import Apr202029 from '../views/Apr202029';
import Jun202015 from '../views/Jun202015';
import May202111 from '../views/May202111';
import Aug202104 from '../views/Aug202104';
import oneYear from '@/views/news/one-year.vue';
import ArchivedPrivacy from '../views/ArchivedPrivacy.vue';
import ArchivedTerms from '../views/ArchivedTerms.vue';
import Termsdec29 from '../views/terms-dec29.vue';
import TermsMarch from '../views/terms-march.vue';
import TermsJuly from '../views/terms-july.vue';
// import TermsMay from '../views/terms-may.vue';
import Privacydec29 from '../views/privacy-dec29.vue';
import PrivacyMarch29 from '../views/privacy-march.vue';
import PrivacyMay2020 from '../views/PrivacyMay2020.vue';
import Permissioncomparison from '../views/SecurityAvailable.vue';
import ToTokPayPrivacy from '../views/ToTokPayPrivacy.vue';
import ToTokPayTerms from '../views/ToTokPayTerms.vue';
import TermsGame from '../views/TermsGame.vue';
import PrivacyGame from '../views/PrivacyGame.vue';
import i18n from '@/i18n';
import store from '@/store';
Vue.use(Router);
Vue.use(Meta);
let routes = [
  {
    path: '/android/totok.apk',
    component: () => import('../views/OnlyDownloadCdnAndroid.vue'),
    name: 'androidToTokApk',
  },
  {
    path: '/dll/:hid',
    component: () => import('../views/download.vue'),
    name: 'dll',
  },
  {
    path: '/dll',
    component: () => import('../views/downloadAndroid.vue'),
    name: 'dll',
  },

  {
    path: '/dli',
    component: () => import('../views/dli.vue'),
    name: 'dli',
  },
  {
    path: '/dli/:hid',
    component: () => import('../views/download.vue'),
    name: 'dli',
  },
  {
    path: '/invite',
    component: () => import('../views/download.vue'),
    name: 'dl',
  },
  {
    path: '/invitation',
    component: () => import('../views/download.vue'),
    name: 'invitation',
  },
  {
    path: '/dlbs',
    component: () => import('../views/dlbs.vue'),
    name: 'dlbs',
  },
  {
    path: '/dlbp',
    component: () => import('../views/dlbp.vue'),
    name: 'dlbp',
  },
  {
    path: '/dlbp',
    component: () => import('../views/dlbp.vue'),
    name: 'dlbp',
  },
  {
    path: '/botim',
    component: () => import('../views/botim.vue'),
    name: 'botim',
  },
  {
    path: '/share',
    component: () => import('../views/botimShare.vue'),
    name: 'share',
  },
  {
    path: '/di',
    component: () => import('../views/botimDb.vue'),
    name: 'di',
  },
  {
    path: '/db',
    component: () => import('../views/botimDb.vue'),
    name: 'db',
  },
  // {
  //   path: '/castle',
  //   component: () => import('../views/Topaypilot.vue'),
  //   name: 'topaypilot',
  // },
  {
    path: '/9mJJA0e6',
    component: () => import('../views/Topaypilot.vue'),
    name: 'topaypilot',
  },
  {
    path: '/topaypilotcode',
    component: () => import('../views/TopaypilotCode.vue'),
    name: 'topaypilotcode',
  },
  // {
  //   path: '/totokmac',
  //   component: () => import('../views/MacDownload.vue'),
  //   name: 'Totokmac',
  // },
  {
    path: '/',
    component: index,
    name: 'index',
    children: [
      {
        path: '',
        component: () => import('../views/main.vue'),
        name: 'main',
      },
      {
        path: '/dl/:hid',
        component: () => import('../views/downloadAndroid.vue'),
        name: 'dl',
      },
      {
        path: '/dl',
        component: () => import('../views/downloadAndroid.vue'),
        name: 'dl',
      },
      {
        path: 'totok-game-terms',
        component: TermsGame,
        name: 'TermsGame',
      },
      {
        path: 'totok-game-privacy',
        component: PrivacyGame,
        name: 'PrivacyGame',
      },
      {
        path: 'totokpayterms',
        component: ToTokPayTerms,
        name: 'ToTokPayTerms',
      },
      {
        path: 'totokpayprivacy',
        component: ToTokPayPrivacy,
        name: 'ToTokPayPrivacy',
      },
      {
        path: 'download',
        component: () => import('../views/download.vue'),
        name: 'download',
      },
      {
        path: 'huawei-9.0',
        component: () => import('../components/FAQ/android/huawei_9.0.vue'),
        name: 'Huawei Android 9.0',
      },
      {
        path: 'huawei-8.0',
        component: () => import('../components/FAQ/android/huawei_8.0.vue'),
        name: 'Huawei Android 8.0',
      },
      {
        path: 'huawei-7.0',
        component: () => import('../components/FAQ/android/huawei_7.0.vue'),
        name: 'Huawei Android 7.0',
      },
      {
        path: 'huawei-6.0',
        component: () => import('../components/FAQ/android/huawei_6.0.vue'),
        name: 'Huawei Android 6.0',
      },
      {
        path: 'huawei-5.1',
        component: () => import('../components/FAQ/android/huawei_5.1.vue'),
        name: 'Huawei Android 5.1',
      },
      {
        path: 'samsung-9.0',
        component: () => import('../components/FAQ/android/samsung_9.0.vue'),
        name: 'samsung 9.0',
      },
      {
        path: 'samsung',
        component: () => import('../components/FAQ/android/samsung.vue'),
        name: 'samsung'
      },
      {
        path: 'xiaomi-9.0',
        component: () => import('../components/FAQ/android/xiaomi_9.0.vue'),
        name: 'xiaomi 9.0',
      },
      {
        path: 'other',
        component: () => import('../components/FAQ/android/other.vue'),
        name: 'other',
      },
      {
        path: 'careers',
        component: () => import('../views/Careers.vue'),
        name: 'careers',
        meta: [
          {
            title: 'Careers - ToTok Messenger',
          },
          {
            property: 'og:title',
            content: 'Careers - ToTok Messenger',
          },
          {
            property: 'og:url',
            content: 'https://totok.ai/careers',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content:
              'careers-https://static.totok.ai/pic/preview/free_unblocked_call.png',
          },
          {
            property: 'og:description',
            content:
              'Enjoy FREE, FAST and FUN calling with your family and friends.',
          },
          {
            property: 'og:site_name',
            content: 'ToTok',
          },
        ],
      },
      {
        path: 'careers/*/',
        component: () => import('../views/Careers.vue'),
        name: 'careers',
      },
      {
        path: 'archivedprivacy',
        component: ArchivedPrivacy,
        name: 'archivedprivacy',
      },
      {
        path: 'archivedterms',
        component: ArchivedTerms,
        name: 'archivedterms',
      },
      {
        path: 'privacy-may-2020',
        component: PrivacyMay2020,
        name: 'privacy-may-2020',
      },
      {
        path: 'privacy-may-2020/*/',
        component: PrivacyMay2020,
        name: 'privacy-may-2020',
      },

      {
        path: 'privacy-march',
        component: PrivacyMarch29,
        name: 'privacy-march',
      },
      {
        path: 'privacy-march/*/',
        component: PrivacyMarch29,
        name: 'privacy-march',
      },
      {
        path: 'privacy-dec29',
        component: Privacydec29,
        name: 'privacy-dec29',
      },
      {
        path: 'privacy-dec29/*/',
        component: Privacydec29,
        name: 'privacy-dec29',
      },
      {
        path: 'privacy',
        component: () => import('../views/privacy.vue'),
        name: 'privacy',
        meta: [
          {
            title: 'Privacy Policy - ToTok Messenger',
          },
          {
            property: 'og:title',
            content: 'Privacy Policy - ToTok Messenger',
          },
          {
            property: 'og:url',
            content: 'https://totok.ai/privacy',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content:
              'privacy-https://static.totok.ai/pic/preview/free_unblocked_call.png',
          },
          {
            property: 'og:description',
            content:
              'Enjoy FREE, FAST and FUN calling with your family and friends.',
          },
          {
            property: 'og:site_name',
            content: 'ToTok',
          },
        ],
      },
      {
        path: 'privacy/*/',
        component: () => import('../views/privacy.vue'),
        name: 'privacy',
      },
      {
        path: 'privacy-pro',
        component: () => import('../views/privacy-pro.vue'),
        name: 'privacy',
        meta: [
          {
            title: 'Privacy Policy - ToTok Messenger',
          },
          {
            property: 'og:title',
            content: 'Privacy Policy - ToTok Messenger',
          },
          {
            property: 'og:url',
            content: 'https://totok.ai/privacy-pro',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content:
              'privacy-https://static.totok.ai/pic/preview/free_unblocked_call.png',
          },
          {
            property: 'og:description',
            content:
              'Enjoy FREE, FAST and FUN calling with your family and friends.',
          },
          {
            property: 'og:site_name',
            content: 'ToTok',
          },
        ],
      },
      {
        path: 'privacy-pro/*/',
        component: () => import('../views/privacy-pro.vue'),
        name: 'privacy-pro',
      },
      {
        path: 'aboutus',
        component: () => import('../views/AboutusNew.vue'),
        name: 'aboutus',
        title: 'Terms of Use - ToTok Messenger',
        meta: {
          title: 'Terms of Use - ToTok Messenger',
          property: [
            {
              property: 'og:title',
              content: 'Terms of Use - ToTok Messenger',
            },
          ],
        },
      },
      {
        path: 'aboutus/*/',
        component: () => import('../views/AboutusNew.vue'),
        name: 'aboutus',
      },
      {
        path: 'terms-may',
        component: TermsMarch,
        name: 'terms-may',
      },
      {
        path: 'terms-aug',
        component: TermsJuly,
        name: 'terms-aug',
      },
      {
        path: 'terms-march',
        component: TermsMarch,
        name: 'terms-march',
      },
      {
        path: 'terms-march/*/',
        component: TermsMarch,
        name: 'terms-march',
      },
      {
        path: 'terms-dec29',
        component: Termsdec29,
        name: 'terms-dec29',
      },
      {
        path: 'terms-dec29/*/',
        component: Termsdec29,
        name: 'terms-dec29',
      },
      {
        path: 'terms',
        component: () => import('../views/terms.vue'),
        name: 'terms',
        title: 'Terms of Use - ToTok Messenger',
        meta: {
          title: 'Terms of Use - ToTok Messenger',
          property: [
            {
              property: 'og:title',
              content: 'Terms of Use - ToTok Messenger',
            },
          ],
        },
      },
      {
        path: 'terms/*/',
        component: () => import('../views/terms.vue'),
        name: 'terms',
      },
      {
        path: 'terms-pro',
        component: () => import('../views/terms-pro.vue'),
        name: 'terms-pro',
        title: 'Terms of Use - ToTok Messenger',
        meta: {
          title: 'Terms of Use - ToTok Messenger',
          property: [
            {
              property: 'og:title',
              content: 'Terms of Use - ToTok Messenger',
            },
          ],
        },
      },
      {
        path: 'terms-pro/*/',
        component: () => import('../views/terms-pro.vue'),
        name: 'terms-pro',
      },
      {
        path: 'contactus',
        component: () => import('../views/Contactus.vue'),
        name: 'contactus',
        title: 'Contact us - ToTok Messenger',
        meta: {
          title: 'Contact us - ToTok Messenger',
          property: [
            {
              property: 'og:title',
              content: 'Contact us - ToTok Messenger',
            },
          ],
        },
      },
      {
        path: 'contactus/*/',
        component: () => import('../views/Contactus.vue'),
        name: 'contactus',
      },
      {
        path: 'about',
        component: () => import('../views/AboutUS.vue'),
        name: 'about',
        title: 'About us - ToTok Messenger',
        meta: {
          title: 'About us - ToTok Messenger',
          property: [
            {
              property: 'og:title',
              content: 'About us - ToTok Messenger',
            },
          ],
        },
      },
      {
        path: 'about/*/',
        component: () => import('../views/About.vue'),
        name: 'about',
      },
      {
        path: 'permission-comparison',
        component: Permissioncomparison,
        name: 'securityAvailable',
      },
      {
        path: 'permission-comparison/*/',
        component: Permissioncomparison,
        name: 'securityAvailable',
      },

      {
        path: 'security',
        component: () => import('../views/Security.vue'),
        name: 'security',
        title: 'Security - ToTok Messenger',
        meta: {
          title: 'Security - ToTok Messenger',
          property: [
            {
              property: 'og:title',
              content: 'Security - ToTok Messenger',
            },
          ],
        },
      },
      {
        path: 'security/*/',
        component: () => import('../views/Security.vue'),
        name: 'security',
      },
      {
        path: 'features',
        component: () => import('../views/FeatureView.vue'),
        name: 'features',
      },
      {
        path: 'features/*/',
        component: () => import('../views/FeatureView.vue'),
        name: 'features',
      },
      {
        path: 'news-mar23-2020',
        component: Mar202023Vue,
        name: 'newsMar202023',
        title: 'News - ToTok Messenger',
        meta: {
          title: 'News - ToTok Messenger',
          property: [
            {
              property: 'og:title',
              content: 'News - ToTok Messenger',
            },
          ],
        },
      },
      {
        path: 'news-mar23-2020/*/',
        component: Mar202011Vue,
        name: 'newsMar202023',
      },
      {
        path: 'news-apr29-2020',
        component: Apr202029,
        name: 'newsApr202029',
        title: 'News - ToTok Messenger',
        meta: {
          title: 'News - ToTok Messenger',
          property: [
            {
              property: 'og:title',
              content: 'News - ToTok Messenger',
            },
          ],
        },
      },
      {
        path: 'news-apr29-2020/*/',
        component: Apr202029,
        name: 'newsApr202029',
      },
      {
        path: 'news-mar11-2020',
        component: Mar202011Vue,
        name: 'newsMar202011',
        title: 'News - ToTok Messenger',
        meta: {
          title: 'News - ToTok Messenger',
          property: [
            {
              property: 'og:title',
              content: 'News - ToTok Messenger',
            },
          ],
        },
      },
      {
        path: 'news-mar11-2020/*/',
        component: Mar202011Vue,
        name: 'newsMar202011',
      },
      {
        path: 'news-mar05-2020',
        component: () => import('../views/Mar202005.vue'),
        name: 'newsMar202005',
        title: 'News - ToTok Messenger',
        meta: {
          title: 'News - ToTok Messenger',
          property: [
            {
              property: 'og:title',
              content: 'News - ToTok Messenger',
            },
          ],
        },
      },
      {
        path: 'news-mar05-2020/*/',
        component: () => import('../views/Mar202005.vue'),
        name: 'newsMar202005',
      },

      {
        path: 'news-feb20-2020',
        component: () => import('../views/Feb202020.vue'),
        name: 'newsFeb202020',
        title: 'News - ToTok Messenger',
        meta: {
          title: 'News - ToTok Messenger',
          property: [
            {
              property: 'og:title',
              content: 'News - ToTok Messenger',
            },
          ],
        },
      },

      {
        path: 'news-feb20-2020/*/',
        component: () => import('../views/Feb202020.vue'),
        name: 'newsFeb202020',
      },
      {
        path: 'news-feb23-2020',
        component: () => import('../views/Feb20200223.vue'),
        name: 'newsFeb20200223',
        title: 'News - ToTok Messenger',
        meta: {
          title: 'News - ToTok Messenger',
          property: [
            {
              property: 'og:title',
              content: 'News - ToTok Messenger',
            },
          ],
        },
      },
      {
        path: 'news-feb23-2020/*/',
        component: () => import('../views/Feb20200223.vue'),
        name: 'newsFeb20200223',
      },
      {
        path: 'news-jan05',
        component: () => import('../views/Jan05.vue'),
        name: 'newsJan05',
        title: 'News - ToTok Messenger',
        meta: {
          title: 'News - ToTok Messenger',
          property: [
            {
              property: 'og:title',
              content: 'News - ToTok Messenger',
            },
          ],
        },
      },
      {
        path: 'news-Jan05/*/',
        component: () => import('../views/Jan05.vue'),
        name: 'newsJan05',
      },
      {
        path: 'news-dec29',
        component: () => import('../views/Dec29.vue'),
        name: 'newsDec29',
        title: 'News - ToTok Messenger',
        meta: {
          title: 'News - ToTok Messenger',
          property: [
            {
              property: 'og:title',
              content: 'News - ToTok Messenger',
            },
          ],
        },
      },
      {
        path: 'news-dec29/*/',
        component: () => import('../views/Dec29.vue'),
        name: 'newsDec29',
      },
      {
        path: 'news-dec27',
        component: () => import('../views/Dec27.vue'),
        name: 'newsDec27',
        title: 'News - ToTok Messenger',
        meta: {
          title: 'News - ToTok Messenger',
          property: [
            {
              property: 'og:title',
              content: 'News - ToTok Messenger',
            },
          ],
        },
      },
      {
        path: 'news-dec27/*/',
        component: () => import('../views/Dec27.vue'),
        name: 'newsDec27',
      },
      {
        path: 'news-dec24',
        component: () => import('../views/Dec24.vue'),
        name: 'newsDec24',
        title: 'News - ToTok Messenger',
        meta: {
          title: 'News - ToTok Messenger',
          property: [
            {
              property: 'og:title',
              content: 'News - ToTok Messenger',
            },
          ],
        },
      },
      {
        path: 'news-dec24/*/',
        component: () => import('../views/Dec24.vue'),
        name: 'newsDec24',
      },

      {
        path: 'android-notifications',
        component: () => import('../views/android_notification.vue'),
        name: 'android_notification',
        title: 'FAQ - ToTok Messenger',
        meta: {
          title: 'FAQ - ToTok Messenger',
          property: [
            {
              property: 'og:title',
              content: 'FAQ - ToTok Messenger',
            },
          ],
        },
      },
      {
        path: 'android-notifications/*/',
        component: () => import('../views/android_notification.vue'),
        name: 'android_notification',
      },
      {
        path: 'news-dec23',
        component: () => import('../views/News.vue'),
        name: 'newsDec22',
        title: 'News - ToTok Messenger',
        meta: {
          title: 'News - ToTok Messenger',
          property: [
            {
              property: 'og:title',
              content: 'News - ToTok Messenger',
            },
          ],
        },
      },
      {
        path: 'news-dec23/*/',
        component: () => import('../views/News.vue'),
        name: 'newsDec22',
      },
      {
        path: 'eidiya-with-totok',
        component: () => import('../views/EidiyaToTok.vue'),
        name: 'EidiyaToTok',
        title: 'News - ToTok Messenger',
        meta: {
          title: 'News - ToTok Messenger',
          property: [
            {
              property: 'og:title',
              content: 'News - ToTok Messenger',
            },
          ],
        },
      },
      {
        path: 'eidiya-with-totok/*/',
        component: () => import('../views/EidiyaToTok.vue'),
        name: 'EidiyaToTok',
      },
      {
        path: 'news-one-year',
        component: oneYear,
        name: 'one-year',
        title: 'Celebrate ToTok’s One Year Anniversary with Us',
        meta: {
          title: 'Celebrate ToTok’s One Year Anniversary with Us',
          property: [
            {
              property: 'og:title',
              content: 'Celebrate ToTok’s One Year Anniversary with Us',
            },
          ],
        },
      },
      {
        path: 'news-jun15-2020',
        component: Jun202015,
        name: 'Jun202015',
        title: 'News - ToTok Messenger',
        meta: {
          title: 'News - ToTok Messenger',
          property: [
            {
              property: 'og:title',
              content: 'News - ToTok Messenger',
            },
          ],
        },
      },
      {
        path: 'news-one-year/*/',
        component: oneYear,
        name: 'one-year',
      },
      {
        path: 'news-May11-2021',
        component: May202111,
        name: 'May202111',
        title: 'Celebrate EID with ToTok!',
        meta: {
          title: 'Celebrate EID with ToTok!',
          property: [
            {
              property: 'og:title',
              content: 'Celebrate EID with ToTok!',
            },
          ],
        },
      },
      {
        path: 'news-Aug04-2021',
        component: Aug202104,
        name: 'Aug202104',
        title: 'Celebrating ToTok’s 2nd Anniversary',
        meta: {
          title: 'Celebrating ToTok’s 2nd Anniversary',
          property: [
            {
              property: 'og:title',
              content: 'Celebrating ToTok’s 2nd Anniversary',
            },
          ],
        },
      },
      // {
      //   path: 'news-jun15-2020/*/',
      //   component: Jun202015,
      //   name: 'Jun202015',
      // },

      {
        path: 'faq/*/:target',
        component: () => import('../views/faq_old_detail.vue'),
        name: 'faq_old_detail',
      },
      {
        path: 'faq/*/:target/*/',
        component: () => import('../views/faq_old_detail.vue'),
        name: 'faq_old_detail',
      },
      {
        path: 'faq/android/',
        component: () => import('../views/faq.vue'),
        name: 'faq_list_android',
        redirect: '/faq',
      },
      {
        path: 'faq/android/*/',
        component: () => import('../views/faq.vue'),
        name: 'faq_list_android',
        redirect: '/faq',
      },
      {
        path: 'faq/ios/',
        component: () => import('../views/faq.vue'),
        name: 'faq_list_ios',
        redirect: '/faq',
      },
      {
        path: 'faq/ios/*/',
        component: () => import('../views/faq.vue'),
        name: 'faq_list_ios',
        redirect: '/faq',
      },
      {
        path: 'faq',
        component: () => import('../views/faq.vue'),
        name: 'faq',
      },
      // {
      //   path: "faq/totokpay",
      //   component: () => import("../views/faq_totokpay.vue"),
      //   name: "faq_totokpay"
      // },
      {
        path: 'faq/:target',
        component: () => import('../views/faq_detail.vue'),
        name: 'faq_detail',
      },

      {
        path: 'download-android/',
        component: () => import('../views/downloadAndroid.vue'),
        name: 'download-android',
      },
      {
        path: 'download-android/*/',
        component: () => import('../views/downloadAndroid.vue'),
        name: 'download-android',
      },
      {
        path: '/*',
        component: () => import('../views/404.vue'),
        name: '404page',
      },
    ],
  },
];

let router = new Router({
  // 设置history以便开启预渲染
  mode: 'history',
  routes: routes,
});

router.beforeEach((to, from, next) => {
  let lang = '';
  if (
    to.query.lang == 'ar' &&
    [
      'download-android',
      'main',
      'features',
      'security',
      'aboutus',
      'one-year',
      'careers',
      'contactus',
    ].indexOf(to.name) != -1
  ) {
    lang = 'ar';
    document.querySelector('html').dir = 'rtl';
  } else {
    lang = 'en';
    document.querySelector('html').dir = 'ltr';
  }
  // 设置全局语言环境
  i18n.locale = lang;
  // 设置全局语言状态
  store.dispatch('setLanguage', lang);
  next();
});
// eslint-disable-next-line no-unused-vars
router.afterEach((to, from, next) => {
  if (document.getElementById('mainbox')) {
    document.getElementById('mainbox').scrollTop = 0;
  }
  document.body.scrollTop = 0;
});
export default router;
